import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Auth from './pages/Auth';
import Home from './pages/Home';
import News from './pages/News';
import NewsFull from './pages/NewsFull';
import AdminGroups from './pages/Admin/AdminGroups';
import AdminUsers from './pages/Admin/AdminUsers';
import AdminRasp from './pages/Admin/AdminRasp';
import AdminLogin from './pages/Admin/AdminLogin';
import AdminGroupFull from './pages/Admin/AdminGroupFull';
import AdminGroupAttendance from './pages/Admin/AdminGroupAttendance';
import AdminSubjects from './pages/Admin/AdminSubjects';
import AdminUserSchedule from './pages/Admin/AdminUserSchedule';
import AdminUserFull from './pages/Admin/AdminUserFull';
import AdminNews from './pages/Admin/AdminNews';
import AdminAttendanceSlot from './pages/Admin/AdminAttendanceSlot';
import StudentAttendance from './pages/StudentAttendance';
import AdminUserAttendance from './pages/Admin/AdminUserAttendance';
import useAdminAuthStore from './stores/adminAuthStore';
import React from 'react';

function isUserAuth() {
  return Boolean(localStorage.getItem('studentToken'));
}

function isAdminAuth() {
  const token = localStorage.getItem('adminToken');
  const admin = localStorage.getItem('adminUser');
  if (!token || !admin) return false;
  try {
    const parsed = JSON.parse(admin);
    return parsed.isAdmin === true;
  } catch {
    return false;
  }
}

function ProtectedRoute({ children }) {
  if (!isUserAuth()) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function GuestRoute({ children }) {
  if (isUserAuth()) {
    return <Navigate to="/home" replace />;
  }
  return children;
}

function AdminProtectedRoute({ children }) {
  if (!isAdminAuth()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

function AdminGuestRoute({ children }) {
  if (isAdminAuth()) {
    return <Navigate to="/admin/groups" replace />;
  }
  return children;
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {}
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, textAlign: 'center', color: '#e74c3c', background: '#fff', minHeight: '100vh' }}>
          <h2>Произошла ошибка в приложении</h2>
          <div style={{ margin: '16px 0', color: '#888' }}>{this.state.error?.message || 'Неизвестная ошибка'}</div>
          <button onClick={() => window.location.reload()} style={{ padding: '8px 24px', borderRadius: 8, background: '#6c3be4', color: '#fff', border: 'none', fontWeight: 500, fontSize: 16 }}>Перезагрузить страницу</button>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={
          <GuestRoute>
            <Auth />
          </GuestRoute>
        } />
        <Route path='/admin' element={isAdminAuth() ? <Navigate to="/admin/groups" replace /> : <Navigate to="/admin/login" replace />} />
        <Route path='/home' element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        } />
        <Route path='/news' element={
          <ProtectedRoute>
            <News />
          </ProtectedRoute>
        } />
        <Route path='/news/:id' element={
          <ProtectedRoute>
            <NewsFull />
          </ProtectedRoute>
        } />

        <Route path='/admin/login' element={
          <AdminGuestRoute>
            <AdminLogin />
          </AdminGuestRoute>
        } />
        <Route path='/admin/groups' element={
          <AdminProtectedRoute>
            <AdminGroups />
          </AdminProtectedRoute>
        } />
        <Route path='/admin/users' element={
          <AdminProtectedRoute>
            <AdminUsers />
          </AdminProtectedRoute>
        } />
        <Route path='/admin/rasp' element={
          <AdminProtectedRoute>
            <AdminRasp />
          </AdminProtectedRoute>
        } />
        <Route path='/admin/groups/:id' element={
          <AdminProtectedRoute>
            <AdminGroupFull />
          </AdminProtectedRoute>
        } />
        <Route path='/admin/groups/:id/attendance' element={
          <AdminProtectedRoute>
            <AdminGroupAttendance />
          </AdminProtectedRoute>
        } />
        <Route path='/admin/subjects' element={
          <AdminProtectedRoute>
            <AdminSubjects />
          </AdminProtectedRoute>
        } />
        <Route path="/admin/user/:id/schedule" element={<AdminUserSchedule />} />
        <Route path="/admin/user/:id/full" element={<AdminUserFull />} />
        <Route path="/admin/news" element={<AdminNews />} />
        <Route path='/admin/attendance/slot' element={
          <AdminProtectedRoute>
            <AdminAttendanceSlot />
          </AdminProtectedRoute>
        } />
        <Route path='/admin/user/:id/attendance' element={
          <AdminProtectedRoute>
            <AdminUserAttendance />
          </AdminProtectedRoute>
        } />
        <Route path='/attendance' element={
          <ProtectedRoute>
            <StudentAttendance />
          </ProtectedRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default function WrappedApp() {
  return (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}
